import React from 'react';
import BaseText from './BaseText';
import Icon from './Icon';
import { Color, CommonStyles } from '../styles';
import RowView from './RowView';

const TextWithIcon = ({ iconName, iconColor, iconSize = 10, style, ...rest }) => {
  return (
    <RowView>
      {iconName && (
        <Icon
          name={iconName}
          size={iconSize}
          color={iconColor || Color.primary}
          style={CommonStyles.mr2}
        />
      )}
      <BaseText style={[CommonStyles.xSmall, style]} {...rest} />
    </RowView>
  );
};

export default TextWithIcon;
